
export default function Gallery() {
  const galleryItems = [
    {
      id: 1,
      title: 'Sunday Ranch Blessing',
      date: 'March 2025',
      bgColor: 'bg-[#FFE4E1]',
      image: 'https://public.readdy.ai/ai/img_res/b85dcbeb669ce47e835065e44ac8b695.jpg'
    },
    {
      id: 2,
      title: 'Youth Ministry Day',
      date: 'February 2025',
      bgColor: 'bg-[#E8F5E9]',
      image: 'https://readdy.ai/api/search-image?query=teenagers%20and%20children%20interacting%20with%20friendly%20longhorn%20cattle%20at%20ranch%20educational%20youth%20program%20joyful%20learning%20experience%20with%20mentors%20guiding%20bright%20outdoor%20setting%20with%20mint%20green%20tones&width=500&height=700&seq=gallery002&orientation=portrait'
    },
    {
      id: 3,
      title: 'Community Harvest',
      date: 'January 2025',
      bgColor: 'bg-[#F5F5F5]',
      image: 'https://readdy.ai/api/search-image?query=volunteers%20distributing%20food%20and%20beef%20donations%20to%20families%20at%20community%20event%20grateful%20people%20receiving%20help%20charitable%20outreach%20program%20with%20ranch%20setting%20warm%20compassionate%20scene%20with%20neutral%20tones&width=500&height=700&seq=gallery003&orientation=portrait'
    },
    {
      id: 4,
      title: 'Easter Sunrise Service',
      date: 'April 2025',
      bgColor: 'bg-[#FFF8DC]',
      image: 'https://readdy.ai/api/search-image?query=sunrise%20easter%20service%20at%20ranch%20with%20large%20cross%20silhouetted%20against%20golden%20dawn%20sky%20longhorn%20cattle%20grazing%20peacefully%20spiritual%20morning%20worship%20beautiful%20resurrection%20celebration%20with%20warm%20yellow%20tones&width=500&height=700&seq=gallery004&orientation=portrait'
    }
  ];

  return (
    <section className="bg-[#FAF8F5] py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex items-start justify-between mb-16">
          <div>
            <span className="text-sm text-[#3E2723] font-serif mb-4 block">GALLERY</span>
            <h2 className="text-6xl font-bold text-[#3E2723]" style={{ fontFamily: 'Playfair Display, serif' }}>
              Moments of Grace
            </h2>
            <h2 className="text-6xl italic text-[#3E2723]" style={{ fontFamily: 'Playfair Display, serif' }}>
              on the Ranch
            </h2>
          </div>
          <div className="text-[#3E2723] text-4xl">✝</div>
        </div>

        {/* Four Column Grid */}
        <div className="grid grid-cols-4 gap-6">
          {galleryItems.map((item) => (
            <div 
              key={item.id}
              className={`${item.bgColor} rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 cursor-pointer`}
            >
              <div className="h-96">
                <img 
                  src={item.image} 
                  alt={item.title} 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="bg-white p-6 text-center">
                <h3 className="text-lg font-semibold text-[#3E2723] mb-1">{item.title}</h3>
                <p className="text-sm text-[#616161]">{item.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
